var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "회사소개",
      "sc": "에프원시큐리티가 여러분의 정보를 함께 보호하겠습니다.",
      "tabActive": "연혁",
      "icon": "/images/sub/visual/sv1-icon.svg",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--lg mb-28 mb-lg-54",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("F1 Security")]), _vm._v(" 는 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 언제나 고객과 함께 나아갑니다 ")]), _c('div', {
    staticClass: "w-100 pa-30 pa-sm-40 px-lg-0 py-lg-80 radius-md his-bg"
  }, [_c('v-row', {
    staticClass: "color-white",
    attrs: {
      "no-gutters": "",
      "align": "end"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center mb-12 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('h4', {
    staticClass: "sub-tit--md"
  }, [_vm._v(" 에프원 시큐리티의 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 발자취 입니다. ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 2012년 10월 정보보안 컨설팅으로 출발하여 웹보안 관련 정보보안 솔루션 개발 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 서비스를 제공하는 과학기술정보통신부 지정 정보보호 전문서비스 기업 입니다. ")])])], 1)], 1), _c('div', {
    staticClass: "tab--wrap mt-60 mt-lg-100"
  }, [_c('v-tabs', {
    staticClass: "mb-40 mb-lg-60",
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v("2022-2020")]), _c('v-tab', [_vm._v("2019-2017")]), _c('v-tab', [_vm._v("2016-2014")]), _c('v-tab', [_vm._v("2013-2011")])], 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "7",
      "sm": "5",
      "md": "4",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "pr-md-20"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "398",
      "src": "/images/sub/about/history/his-tit1.svg"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "mt-18 mt-lg-70"
  }, [_c('div', {
    staticClass: "mb-24 mb-lg-74"
  }, [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2022 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("01")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 2022년 웹취약점 점검 및 웹보안도구 보급 용역 사업 수주(한국인터넷진흥원) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("01")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 2022년 침해사고 탐지정보 분석·대응 지원 용역 사업 수주(한국인터넷진흥원) ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("01")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 2022년 내PC 돌보미 서비스 운영 사업 수주(한국인터넷진흥원) ")])])])]), _c('div', {
    staticClass: "mb-24 mb-lg-74"
  }, [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2021 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("01")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 방산보안연구소 MOU 체결 ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("02")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 한국정보기술전략혁신학회(KIITI) 미래융합기술연구소 MOU 체결 ")])])])]), _c('div', [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2020 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("01")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허등록(블록체인을 이용한 공동주택 관리 시스템 및 방법) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("02")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 상표등록(특허청 Secure DNS), 상표 등록(특허청 WSFinder 상표 등록) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("07")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 한국인터넷진흥원 “2020년 클라우드 보안서비스 고도화 지원사업” 사업자 선정 ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("09")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" UWSS(통합웹보안서비스) 출시 ")])])])])])])], 1)], 1), _c('v-tab-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "7",
      "sm": "5",
      "md": "4",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "pr-md-20"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "365",
      "src": "/images/sub/about/history/his-tit2.svg"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "mt-18 mt-lg-70"
  }, [_c('div', {
    staticClass: "mb-24 mb-lg-74"
  }, [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2019 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("02")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 상표 등록(특허청 F1SECURITY 상표 등록) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("03")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허등록(DNS 서버에 기반한 감염 시스템의 원점 추적 방지 및 시스템 웹공격 탐지 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 및 차단 시스템 및 그방법) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("03")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 상표 출원(특허청 WSFinder 상표 출원) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("04")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허등록(악성코드 탐지 장치 및 방법), 상표출원(특허청 webcastle 상표출원) ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("05")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 과학기술정보통신부 \"정보보호 전문서비스 기업 지정\" ")])])])]), _c('div', {
    staticClass: "mb-24 mb-lg-74"
  }, [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2018 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("01")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허출원(웹 쉘 탐지 시스템), 해커프리 웹콘 웹방화벽 인수 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("04")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 한국인터넷진흥원 ‘중소기업 정보보호 컨설팅 사업자 선정 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("05")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 서울시 창업성장센터(월곡) 본사이전 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("06")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" ISO27001 인증 획득 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("06")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허등록(웹 쉘 탐지 시스템), 특허출원(웹 공격 탐지 및 차단 시스템 및 그 방법) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("06")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 가산 STVX로 기술연구소 확장이전 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("08")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허등록(웹사이트 위변조 탐지 방법 및 시스템) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("09")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 한국해킹보안협회 기업부문 수상 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("10")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 해외PCT출원(웹 공격 탐지 및 차단 시스템 및 그 방법, 악성코드 탐지 장치 및 방법) ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("10")]), _c('p', {
    staticClass: "color-gray",
    staticStyle: {
      "letter-spacing": "-0.02em !important"
    }
  }, [_vm._v(" 특허출원(DNS 서버에 기반한 감염 시스템의 원점 추적 방법 및 시스템), 코리아리더대상 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 정보보안산업 부문 대상 ")])])])]), _c('div', [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2017 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("02")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 상표등록(특허청 WMDS 상표 등록) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("05")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 정보통신산업진흥원(NIPA) 2017년 GSIP 아이디어형 SaaS 개발 지원과제 선정 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("06")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 서울형 강소기업 선정 (서울특별시 협약) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("07")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 서울시 Hi Seoul 브랜드 인증 사용권 기업 선정 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("08")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 국보연 특허 기술이전(프로세스 행위 예측 기법을 이용한 비정형 악성코드 탐지방법 및 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 그 시스템) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("08")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허출원 (머신러닝을 이용한 악성코드 유포지 위험도 분석시스템) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("08")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 서울시 ‘퍼지해시를 이용한 웹 셸 유사도 탐지 시스템 개발’ 사업자 선정 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("10")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 상표 출원(특허청 F1SECURITY 상표 출원) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("12")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 기술혁신형 중소기업(Inno-Biz) 인증 ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("12")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허취득(머신러닝을 이용한 악성코드 유포지 위험도 분석 시스템) ")])])])])])])], 1)], 1), _c('v-tab-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "7",
      "sm": "5",
      "md": "4",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "pr-md-20"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "371",
      "src": "/images/sub/about/history/his-tit3.svg"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "mt-18 mt-lg-70"
  }, [_c('div', {
    staticClass: "mb-24 mb-lg-74"
  }, [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2016 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("02")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 웹사이트 악성코드 유포탐지 솔루션(F1-WMDS V2.0) 출시 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("04")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" GS인증 1등급(소프트웨어품질인증서, TTA) 획득 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("05")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 웹사이트 악성코드 유포탐지 시스템 프로그램 등록 (한국저작권위원회) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("06")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 서울시 일자리창출 지원사업 대상 선정 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("09")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 정보통신산업진흥원(NIPA) 2016년 GSIP 정보생활형 활용 SaaS 개발 지원대상 선정 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("09")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 조달청 구매물품등록 (웹사이트 악성코드 유포탐지 솔루션 F1-WMDS V2.0) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("11")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 클라우드서비스 확인서 취득(한국클라우드산업협회) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("11")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허취득(웹 사이트의 악성코드 탐지 및 차단시스템) ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("12")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 클라우드스토어 씨앗 WMDS CLOUD 서비스 등록 ")])])])]), _c('div', {
    staticClass: "mb-24 mb-lg-74"
  }, [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2015 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("05")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허취득(웹사이트 악성코드유포 탐지 및 차단 시스템) ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("06")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 중기청 기술혁신과제 지원대상 선정 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("06")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" IBK기업은행 투자기업 인증 취득 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("08")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 익스플로잇 코드를 탐지하는 네트워크 보안시스템 및 방법 기술이전 (한국전자통신연구원) ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("06")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 특허취득(악성프로그램 탐지장치 및 그 방법) ")])])])]), _c('div', [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2014 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("03")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 한국인터넷진흥원 웹사이트 악성코드탐지 기술이전 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("10")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 홈페이지 악성코드 유포탐지 솔루션(F1-WMDS) 출시 ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("12")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 서울 Rising Star 기업 선정 ")])])])])])])], 1)], 1), _c('v-tab-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "7",
      "sm": "5",
      "md": "4",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "pr-md-20"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "340",
      "src": "/images/sub/about/history/his-tit4.svg"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "mt-18 mt-lg-70"
  }, [_c('div', {
    staticClass: "mb-24 mb-lg-74"
  }, [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2013 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("04")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 기업부설연구소 설립 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("05")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 조달청 조달업체 등록 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("05")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 소프트웨어 사업자 등록 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("06")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 벤처기업 인증, 유망창업기업 고용창출지원대상기업 선정 ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("07")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 중소기업 기술보호상담 전문기관 등록 ")])])])]), _c('div', {
    staticClass: "mb-24 mb-lg-74"
  }, [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2012 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("04")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 호서시니어창업보육센터(서초) 입주 ")])]), _c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("08")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 서울시창업지원센터(구로) 입주 이전 ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("10")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" (주)에프원시큐리티 법인설립 ")])])])]), _c('div', [_c('div', {
    staticClass: "his-year"
  }, [_c('h4', {
    staticClass: "sub-tit--md pb-10 pb-lg-24 border-bottom font-weigth-bold line-height-1 mb-16 mb-lg-32"
  }, [_vm._v(" 2011 ")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('div', {
    staticClass: "d-flex mb-8 mb-lg-20"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("07")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 설립, 정보보호컨설팅 서비스 전문 ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "min-w-40px min-w-lg-60px font-weight-bold"
  }, [_vm._v("10")]), _c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 1인창조기업 등록 ")])])])])])])], 1)], 1)], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }